// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.11.2
//   protoc               v5.26.1
// source: portal/atk_equipment.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { Autotractor, Implement, ImplementArchetype, Tractor, TractorArchetype } from "../atk/autotractor";
import {
  EffectiveConfigValidationMode,
  effectiveConfigValidationModeFromJSON,
  effectiveConfigValidationModeToJSON,
  RigEffectiveConfig,
} from "../atk/effective_config";
import {
  AutonomousActivityType,
  autonomousActivityTypeFromJSON,
  autonomousActivityTypeToJSON,
  HitchType,
  hitchTypeFromJSON,
  hitchTypeToJSON,
  PtoSpeed,
  ptoSpeedFromJSON,
  ptoSpeedToJSON,
  PtoType,
  ptoTypeFromJSON,
  ptoTypeToJSON,
} from "../atk/enums";

export const protobufPackage = "carbon.portal.atk_equipment";

export enum RigCompatibilityStatus {
  COMPATIBILITY_STATUS_UNRECOGNIZED = 0,
  COMPATIBILITY_STATUS_OK = 1,
  COMPATIBILITY_STATUS_WARNING = 2,
  COMPATIBILITY_STATUS_ERROR = 3,
  COMPATIBILITY_STATUS_ERROR_SWITCH_RIG = 4,
  UNRECOGNIZED = -1,
}

export function rigCompatibilityStatusFromJSON(object: any): RigCompatibilityStatus {
  switch (object) {
    case 0:
    case "COMPATIBILITY_STATUS_UNRECOGNIZED":
      return RigCompatibilityStatus.COMPATIBILITY_STATUS_UNRECOGNIZED;
    case 1:
    case "COMPATIBILITY_STATUS_OK":
      return RigCompatibilityStatus.COMPATIBILITY_STATUS_OK;
    case 2:
    case "COMPATIBILITY_STATUS_WARNING":
      return RigCompatibilityStatus.COMPATIBILITY_STATUS_WARNING;
    case 3:
    case "COMPATIBILITY_STATUS_ERROR":
      return RigCompatibilityStatus.COMPATIBILITY_STATUS_ERROR;
    case 4:
    case "COMPATIBILITY_STATUS_ERROR_SWITCH_RIG":
      return RigCompatibilityStatus.COMPATIBILITY_STATUS_ERROR_SWITCH_RIG;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RigCompatibilityStatus.UNRECOGNIZED;
  }
}

export function rigCompatibilityStatusToJSON(object: RigCompatibilityStatus): string {
  switch (object) {
    case RigCompatibilityStatus.COMPATIBILITY_STATUS_UNRECOGNIZED:
      return "COMPATIBILITY_STATUS_UNRECOGNIZED";
    case RigCompatibilityStatus.COMPATIBILITY_STATUS_OK:
      return "COMPATIBILITY_STATUS_OK";
    case RigCompatibilityStatus.COMPATIBILITY_STATUS_WARNING:
      return "COMPATIBILITY_STATUS_WARNING";
    case RigCompatibilityStatus.COMPATIBILITY_STATUS_ERROR:
      return "COMPATIBILITY_STATUS_ERROR";
    case RigCompatibilityStatus.COMPATIBILITY_STATUS_ERROR_SWITCH_RIG:
      return "COMPATIBILITY_STATUS_ERROR_SWITCH_RIG";
    case RigCompatibilityStatus.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

/**
 * /////////////////////////////////////////////////////////////////////////////
 * structured error responses for methods which perform config validation
 * /////////////////////////////////////////////////////////////////////////////
 */
export enum ConfigValidationStatusCode {
  VALIDATION_STATUS_UNSPECIFIED = 0,
  VALIDATION_STATUS_NO_TRACTOR = 1,
  VALIDATION_STATUS_HITCH_TYPE_NOT_UNIQUE = 2,
  VALIDATION_STATUS_UNSPECIFIED_PTO_REQUIREMENT = 3,
  VALIDATION_STATUS_NO_COMPATIBLE_HITCH = 4,
  VALIDATION_STATUS_PTO_SPEED_NOT_SUPPORTED = 5,
  VALIDATION_STATUS_SCV_CONNECTION_INVALID_INPUT_ID = 6,
  VALIDATION_STATUS_SCV_CONNECTION_INVALID_OUTPUT_ID = 7,
  VALIDATION_STATUS_NO_ACTIVE_RIG = 8,
  VALIDATION_STATUS_TOPLINK_INVALID_OUTPUT_ID = 9,
  /**
   * VALIDATION_STATUS_INVALID_RIG_IGNORED - the operation requested the current tractor effective configuration; the
   * ATK kit has a rig assigned but it is malformed and its effective
   * configuration cannot be determined, so the effective configuration of the
   * default tractor was returned instead.
   */
  VALIDATION_STATUS_INVALID_RIG_IGNORED = 10,
  VALIDATION_STATUS_TRACTOR_CAPTURE_NOT_COMPLETE = 11,
  VALIDATION_STATUS_IMPLEMENT_CAPTURE_NOT_COMPLETE = 12,
  /**
   * VALIDATION_STATUS_DEPRECATED_TOPLINK_HANDLING - the autotractor is configured with an M6 or later data model but still uses
   * legacy toplink handling
   */
  VALIDATION_STATUS_DEPRECATED_TOPLINK_HANDLING = 13,
  VALIDATION_STATUS_SCV_ACTION_NOT_CONNECTED = 14,
  VALIDATION_STATUS_SCV_ACTION_INVALID_INPUT_ID = 15,
  /**
   * VALIDATION_STATUS_SCV_ACTION_NO_POSITION_SENSOR - the activity configuration contains an SCV action which requires position
   * monitoring (move to position, hold position), but no position sensor is
   * connected to the specified SCV input
   */
  VALIDATION_STATUS_SCV_ACTION_NO_POSITION_SENSOR = 16,
  VALIDATION_STATUS_PTO_ACTION_NO_SUCH_PTO = 17,
  VALIDATION_STATUS_HITCH_ACTION_NO_SUCH_HITCH = 18,
  /**
   * VALIDATION_STATUS_CUSTOM_IMPLEMENT_REQUIRED_FIELD_MISSING - the implement has no archetype, and is missing one or more pieces of
   * configuration data that is required
   */
  VALIDATION_STATUS_CUSTOM_IMPLEMENT_REQUIRED_FIELD_MISSING = 19,
  UNRECOGNIZED = -1,
}

export function configValidationStatusCodeFromJSON(object: any): ConfigValidationStatusCode {
  switch (object) {
    case 0:
    case "VALIDATION_STATUS_UNSPECIFIED":
      return ConfigValidationStatusCode.VALIDATION_STATUS_UNSPECIFIED;
    case 1:
    case "VALIDATION_STATUS_NO_TRACTOR":
      return ConfigValidationStatusCode.VALIDATION_STATUS_NO_TRACTOR;
    case 2:
    case "VALIDATION_STATUS_HITCH_TYPE_NOT_UNIQUE":
      return ConfigValidationStatusCode.VALIDATION_STATUS_HITCH_TYPE_NOT_UNIQUE;
    case 3:
    case "VALIDATION_STATUS_UNSPECIFIED_PTO_REQUIREMENT":
      return ConfigValidationStatusCode.VALIDATION_STATUS_UNSPECIFIED_PTO_REQUIREMENT;
    case 4:
    case "VALIDATION_STATUS_NO_COMPATIBLE_HITCH":
      return ConfigValidationStatusCode.VALIDATION_STATUS_NO_COMPATIBLE_HITCH;
    case 5:
    case "VALIDATION_STATUS_PTO_SPEED_NOT_SUPPORTED":
      return ConfigValidationStatusCode.VALIDATION_STATUS_PTO_SPEED_NOT_SUPPORTED;
    case 6:
    case "VALIDATION_STATUS_SCV_CONNECTION_INVALID_INPUT_ID":
      return ConfigValidationStatusCode.VALIDATION_STATUS_SCV_CONNECTION_INVALID_INPUT_ID;
    case 7:
    case "VALIDATION_STATUS_SCV_CONNECTION_INVALID_OUTPUT_ID":
      return ConfigValidationStatusCode.VALIDATION_STATUS_SCV_CONNECTION_INVALID_OUTPUT_ID;
    case 8:
    case "VALIDATION_STATUS_NO_ACTIVE_RIG":
      return ConfigValidationStatusCode.VALIDATION_STATUS_NO_ACTIVE_RIG;
    case 9:
    case "VALIDATION_STATUS_TOPLINK_INVALID_OUTPUT_ID":
      return ConfigValidationStatusCode.VALIDATION_STATUS_TOPLINK_INVALID_OUTPUT_ID;
    case 10:
    case "VALIDATION_STATUS_INVALID_RIG_IGNORED":
      return ConfigValidationStatusCode.VALIDATION_STATUS_INVALID_RIG_IGNORED;
    case 11:
    case "VALIDATION_STATUS_TRACTOR_CAPTURE_NOT_COMPLETE":
      return ConfigValidationStatusCode.VALIDATION_STATUS_TRACTOR_CAPTURE_NOT_COMPLETE;
    case 12:
    case "VALIDATION_STATUS_IMPLEMENT_CAPTURE_NOT_COMPLETE":
      return ConfigValidationStatusCode.VALIDATION_STATUS_IMPLEMENT_CAPTURE_NOT_COMPLETE;
    case 13:
    case "VALIDATION_STATUS_DEPRECATED_TOPLINK_HANDLING":
      return ConfigValidationStatusCode.VALIDATION_STATUS_DEPRECATED_TOPLINK_HANDLING;
    case 14:
    case "VALIDATION_STATUS_SCV_ACTION_NOT_CONNECTED":
      return ConfigValidationStatusCode.VALIDATION_STATUS_SCV_ACTION_NOT_CONNECTED;
    case 15:
    case "VALIDATION_STATUS_SCV_ACTION_INVALID_INPUT_ID":
      return ConfigValidationStatusCode.VALIDATION_STATUS_SCV_ACTION_INVALID_INPUT_ID;
    case 16:
    case "VALIDATION_STATUS_SCV_ACTION_NO_POSITION_SENSOR":
      return ConfigValidationStatusCode.VALIDATION_STATUS_SCV_ACTION_NO_POSITION_SENSOR;
    case 17:
    case "VALIDATION_STATUS_PTO_ACTION_NO_SUCH_PTO":
      return ConfigValidationStatusCode.VALIDATION_STATUS_PTO_ACTION_NO_SUCH_PTO;
    case 18:
    case "VALIDATION_STATUS_HITCH_ACTION_NO_SUCH_HITCH":
      return ConfigValidationStatusCode.VALIDATION_STATUS_HITCH_ACTION_NO_SUCH_HITCH;
    case 19:
    case "VALIDATION_STATUS_CUSTOM_IMPLEMENT_REQUIRED_FIELD_MISSING":
      return ConfigValidationStatusCode.VALIDATION_STATUS_CUSTOM_IMPLEMENT_REQUIRED_FIELD_MISSING;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ConfigValidationStatusCode.UNRECOGNIZED;
  }
}

export function configValidationStatusCodeToJSON(object: ConfigValidationStatusCode): string {
  switch (object) {
    case ConfigValidationStatusCode.VALIDATION_STATUS_UNSPECIFIED:
      return "VALIDATION_STATUS_UNSPECIFIED";
    case ConfigValidationStatusCode.VALIDATION_STATUS_NO_TRACTOR:
      return "VALIDATION_STATUS_NO_TRACTOR";
    case ConfigValidationStatusCode.VALIDATION_STATUS_HITCH_TYPE_NOT_UNIQUE:
      return "VALIDATION_STATUS_HITCH_TYPE_NOT_UNIQUE";
    case ConfigValidationStatusCode.VALIDATION_STATUS_UNSPECIFIED_PTO_REQUIREMENT:
      return "VALIDATION_STATUS_UNSPECIFIED_PTO_REQUIREMENT";
    case ConfigValidationStatusCode.VALIDATION_STATUS_NO_COMPATIBLE_HITCH:
      return "VALIDATION_STATUS_NO_COMPATIBLE_HITCH";
    case ConfigValidationStatusCode.VALIDATION_STATUS_PTO_SPEED_NOT_SUPPORTED:
      return "VALIDATION_STATUS_PTO_SPEED_NOT_SUPPORTED";
    case ConfigValidationStatusCode.VALIDATION_STATUS_SCV_CONNECTION_INVALID_INPUT_ID:
      return "VALIDATION_STATUS_SCV_CONNECTION_INVALID_INPUT_ID";
    case ConfigValidationStatusCode.VALIDATION_STATUS_SCV_CONNECTION_INVALID_OUTPUT_ID:
      return "VALIDATION_STATUS_SCV_CONNECTION_INVALID_OUTPUT_ID";
    case ConfigValidationStatusCode.VALIDATION_STATUS_NO_ACTIVE_RIG:
      return "VALIDATION_STATUS_NO_ACTIVE_RIG";
    case ConfigValidationStatusCode.VALIDATION_STATUS_TOPLINK_INVALID_OUTPUT_ID:
      return "VALIDATION_STATUS_TOPLINK_INVALID_OUTPUT_ID";
    case ConfigValidationStatusCode.VALIDATION_STATUS_INVALID_RIG_IGNORED:
      return "VALIDATION_STATUS_INVALID_RIG_IGNORED";
    case ConfigValidationStatusCode.VALIDATION_STATUS_TRACTOR_CAPTURE_NOT_COMPLETE:
      return "VALIDATION_STATUS_TRACTOR_CAPTURE_NOT_COMPLETE";
    case ConfigValidationStatusCode.VALIDATION_STATUS_IMPLEMENT_CAPTURE_NOT_COMPLETE:
      return "VALIDATION_STATUS_IMPLEMENT_CAPTURE_NOT_COMPLETE";
    case ConfigValidationStatusCode.VALIDATION_STATUS_DEPRECATED_TOPLINK_HANDLING:
      return "VALIDATION_STATUS_DEPRECATED_TOPLINK_HANDLING";
    case ConfigValidationStatusCode.VALIDATION_STATUS_SCV_ACTION_NOT_CONNECTED:
      return "VALIDATION_STATUS_SCV_ACTION_NOT_CONNECTED";
    case ConfigValidationStatusCode.VALIDATION_STATUS_SCV_ACTION_INVALID_INPUT_ID:
      return "VALIDATION_STATUS_SCV_ACTION_INVALID_INPUT_ID";
    case ConfigValidationStatusCode.VALIDATION_STATUS_SCV_ACTION_NO_POSITION_SENSOR:
      return "VALIDATION_STATUS_SCV_ACTION_NO_POSITION_SENSOR";
    case ConfigValidationStatusCode.VALIDATION_STATUS_PTO_ACTION_NO_SUCH_PTO:
      return "VALIDATION_STATUS_PTO_ACTION_NO_SUCH_PTO";
    case ConfigValidationStatusCode.VALIDATION_STATUS_HITCH_ACTION_NO_SUCH_HITCH:
      return "VALIDATION_STATUS_HITCH_ACTION_NO_SUCH_HITCH";
    case ConfigValidationStatusCode.VALIDATION_STATUS_CUSTOM_IMPLEMENT_REQUIRED_FIELD_MISSING:
      return "VALIDATION_STATUS_CUSTOM_IMPLEMENT_REQUIRED_FIELD_MISSING";
    case ConfigValidationStatusCode.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

export interface GetRigResponse {
  rig: Autotractor | undefined;
  validationResult?: RigValidationResult | undefined;
}

export interface RigValidationResult {
  effectiveConfig?: RigEffectiveConfig | undefined;
  validationResult: ConfigValidationResult | undefined;
}

export interface SearchTractorArchetypesRequest {
  query?: string | undefined;
  pageToken?: string | undefined;
  pageSize?: number | undefined;
}

export interface SearchTractorArchetypesResponse {
  archetypes: TractorArchetype[];
  nextPageToken?: string | undefined;
}

export interface SearchImplementArchetypesRequest {
  query?: string | undefined;
  pageToken?: string | undefined;
  pageSize?: number | undefined;
}

export interface SearchImplementArchetypesResponse {
  archetypes: ImplementArchetype[];
  nextPageToken?: string | undefined;
}

export interface SearchRigsRequest {
  customerId?: string | undefined;
  rigId?: string | undefined;
  serial?: string | undefined;
  pageToken?: string | undefined;
  pageSize?:
    | number
    | undefined;
  /**
   * whether to validate that each rig's configuration can be used for operation
   * before returning a list of results
   */
  validate?: boolean | undefined;
  validationMode?: EffectiveConfigValidationMode | undefined;
}

export interface SearchRigsResponse {
  rigs: Autotractor[];
  nextPageToken?:
    | string
    | undefined;
  /**
   * if the request was issued with "validate": true, the result of validating
   * the configuration of each rig in the result set
   */
  validationResults: { [key: string]: ConfigValidationResult };
}

export interface SearchRigsResponse_ValidationResultsEntry {
  key: string;
  value: ConfigValidationResult | undefined;
}

export interface SearchTractorsRequest {
  customerId?: string | undefined;
  pageToken?: string | undefined;
  pageSize?: number | undefined;
  tractorId?: string | undefined;
}

export interface SearchTractorsResponse {
  tractors: Tractor[];
  nextPageToken?: string | undefined;
}

export interface SearchImplementsRequest {
  customerId?: string | undefined;
  pageToken?: string | undefined;
  pageSize?: number | undefined;
  implementId?: string | undefined;
}

export interface SearchImplementsResponse {
  implements: Implement[];
  nextPageToken?: string | undefined;
}

export interface RigSnapshotResponse {
  snapshotId: string;
  effectiveConfig: RigEffectiveConfig | undefined;
}

export interface CheckRigCompatibilityResponse {
  status: RigCompatibilityStatus;
}

export interface ListCompatibleRobotsResponse {
  /** key is the robot serial */
  robots: { [key: string]: CheckRigCompatibilityResponse };
}

export interface ListCompatibleRobotsResponse_RobotsEntry {
  key: string;
  value: CheckRigCompatibilityResponse | undefined;
}

export interface GetNextRigEffectiveConfigRequest {
  timestampMs: number;
}

export interface GetNextRigEffectiveConfigResponse {
  config?: RigEffectiveConfig | undefined;
  validationResult: ConfigValidationResult | undefined;
  timestampMs: number;
}

export interface ConfigValidationDetails {
  statusCode: ConfigValidationStatusCode;
  implementId?: string | undefined;
  scvConnectionId?: string | undefined;
  scvInputId?: string | undefined;
  scvOutputId?: string | undefined;
  hitchType?: HitchType | undefined;
  ptoSpeed?: PtoSpeed | undefined;
  ptoType?: PtoType | undefined;
  actionId?: string | undefined;
  activity?: AutonomousActivityType | undefined;
}

export interface ConfigValidationResult {
  warnings: ConfigValidationDetails[];
  errors: ConfigValidationDetails[];
}

function createBaseGetRigResponse(): GetRigResponse {
  return { rig: undefined, validationResult: undefined };
}

export const GetRigResponse: MessageFns<GetRigResponse> = {
  encode(message: GetRigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.rig !== undefined) {
      Autotractor.encode(message.rig, writer.uint32(10).fork()).join();
    }
    if (message.validationResult !== undefined) {
      RigValidationResult.encode(message.validationResult, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetRigResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetRigResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rig = Autotractor.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.validationResult = RigValidationResult.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetRigResponse {
    return {
      rig: isSet(object.rig) ? Autotractor.fromJSON(object.rig) : undefined,
      validationResult: isSet(object.validationResult)
        ? RigValidationResult.fromJSON(object.validationResult)
        : isSet(object.validation_result)
        ? RigValidationResult.fromJSON(object.validation_result)
        : undefined,
    };
  },

  toJSON(message: GetRigResponse): unknown {
    const obj: any = {};
    if (message.rig !== undefined) {
      obj.rig = Autotractor.toJSON(message.rig);
    }
    if (message.validationResult !== undefined) {
      obj.validationResult = RigValidationResult.toJSON(message.validationResult);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetRigResponse>, I>>(base?: I): GetRigResponse {
    return GetRigResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetRigResponse>, I>>(object: I): GetRigResponse {
    const message = createBaseGetRigResponse();
    message.rig = (object.rig !== undefined && object.rig !== null) ? Autotractor.fromPartial(object.rig) : undefined;
    message.validationResult = (object.validationResult !== undefined && object.validationResult !== null)
      ? RigValidationResult.fromPartial(object.validationResult)
      : undefined;
    return message;
  },
};

function createBaseRigValidationResult(): RigValidationResult {
  return { effectiveConfig: undefined, validationResult: undefined };
}

export const RigValidationResult: MessageFns<RigValidationResult> = {
  encode(message: RigValidationResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.effectiveConfig !== undefined) {
      RigEffectiveConfig.encode(message.effectiveConfig, writer.uint32(10).fork()).join();
    }
    if (message.validationResult !== undefined) {
      ConfigValidationResult.encode(message.validationResult, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RigValidationResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRigValidationResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.effectiveConfig = RigEffectiveConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.validationResult = ConfigValidationResult.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RigValidationResult {
    return {
      effectiveConfig: isSet(object.effectiveConfig)
        ? RigEffectiveConfig.fromJSON(object.effectiveConfig)
        : isSet(object.effective_config)
        ? RigEffectiveConfig.fromJSON(object.effective_config)
        : undefined,
      validationResult: isSet(object.validationResult)
        ? ConfigValidationResult.fromJSON(object.validationResult)
        : isSet(object.validation_result)
        ? ConfigValidationResult.fromJSON(object.validation_result)
        : undefined,
    };
  },

  toJSON(message: RigValidationResult): unknown {
    const obj: any = {};
    if (message.effectiveConfig !== undefined) {
      obj.effectiveConfig = RigEffectiveConfig.toJSON(message.effectiveConfig);
    }
    if (message.validationResult !== undefined) {
      obj.validationResult = ConfigValidationResult.toJSON(message.validationResult);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RigValidationResult>, I>>(base?: I): RigValidationResult {
    return RigValidationResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RigValidationResult>, I>>(object: I): RigValidationResult {
    const message = createBaseRigValidationResult();
    message.effectiveConfig = (object.effectiveConfig !== undefined && object.effectiveConfig !== null)
      ? RigEffectiveConfig.fromPartial(object.effectiveConfig)
      : undefined;
    message.validationResult = (object.validationResult !== undefined && object.validationResult !== null)
      ? ConfigValidationResult.fromPartial(object.validationResult)
      : undefined;
    return message;
  },
};

function createBaseSearchTractorArchetypesRequest(): SearchTractorArchetypesRequest {
  return { query: undefined, pageToken: undefined, pageSize: undefined };
}

export const SearchTractorArchetypesRequest: MessageFns<SearchTractorArchetypesRequest> = {
  encode(message: SearchTractorArchetypesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.query !== undefined) {
      writer.uint32(10).string(message.query);
    }
    if (message.pageToken !== undefined) {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.pageSize !== undefined) {
      writer.uint32(24).int32(message.pageSize);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchTractorArchetypesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchTractorArchetypesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.query = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchTractorArchetypesRequest {
    return {
      query: isSet(object.query) ? globalThis.String(object.query) : undefined,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : undefined,
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : undefined,
    };
  },

  toJSON(message: SearchTractorArchetypesRequest): unknown {
    const obj: any = {};
    if (message.query !== undefined) {
      obj.query = message.query;
    }
    if (message.pageToken !== undefined) {
      obj.pageToken = message.pageToken;
    }
    if (message.pageSize !== undefined) {
      obj.pageSize = Math.round(message.pageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchTractorArchetypesRequest>, I>>(base?: I): SearchTractorArchetypesRequest {
    return SearchTractorArchetypesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchTractorArchetypesRequest>, I>>(
    object: I,
  ): SearchTractorArchetypesRequest {
    const message = createBaseSearchTractorArchetypesRequest();
    message.query = object.query ?? undefined;
    message.pageToken = object.pageToken ?? undefined;
    message.pageSize = object.pageSize ?? undefined;
    return message;
  },
};

function createBaseSearchTractorArchetypesResponse(): SearchTractorArchetypesResponse {
  return { archetypes: [], nextPageToken: undefined };
}

export const SearchTractorArchetypesResponse: MessageFns<SearchTractorArchetypesResponse> = {
  encode(message: SearchTractorArchetypesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.archetypes) {
      TractorArchetype.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== undefined) {
      writer.uint32(18).string(message.nextPageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchTractorArchetypesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchTractorArchetypesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.archetypes.push(TractorArchetype.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchTractorArchetypesResponse {
    return {
      archetypes: globalThis.Array.isArray(object?.archetypes)
        ? object.archetypes.map((e: any) => TractorArchetype.fromJSON(e))
        : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : undefined,
    };
  },

  toJSON(message: SearchTractorArchetypesResponse): unknown {
    const obj: any = {};
    if (message.archetypes?.length) {
      obj.archetypes = message.archetypes.map((e) => TractorArchetype.toJSON(e));
    }
    if (message.nextPageToken !== undefined) {
      obj.nextPageToken = message.nextPageToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchTractorArchetypesResponse>, I>>(base?: I): SearchTractorArchetypesResponse {
    return SearchTractorArchetypesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchTractorArchetypesResponse>, I>>(
    object: I,
  ): SearchTractorArchetypesResponse {
    const message = createBaseSearchTractorArchetypesResponse();
    message.archetypes = object.archetypes?.map((e) => TractorArchetype.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? undefined;
    return message;
  },
};

function createBaseSearchImplementArchetypesRequest(): SearchImplementArchetypesRequest {
  return { query: undefined, pageToken: undefined, pageSize: undefined };
}

export const SearchImplementArchetypesRequest: MessageFns<SearchImplementArchetypesRequest> = {
  encode(message: SearchImplementArchetypesRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.query !== undefined) {
      writer.uint32(10).string(message.query);
    }
    if (message.pageToken !== undefined) {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.pageSize !== undefined) {
      writer.uint32(24).int32(message.pageSize);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchImplementArchetypesRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchImplementArchetypesRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.query = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchImplementArchetypesRequest {
    return {
      query: isSet(object.query) ? globalThis.String(object.query) : undefined,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : undefined,
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : undefined,
    };
  },

  toJSON(message: SearchImplementArchetypesRequest): unknown {
    const obj: any = {};
    if (message.query !== undefined) {
      obj.query = message.query;
    }
    if (message.pageToken !== undefined) {
      obj.pageToken = message.pageToken;
    }
    if (message.pageSize !== undefined) {
      obj.pageSize = Math.round(message.pageSize);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchImplementArchetypesRequest>, I>>(
    base?: I,
  ): SearchImplementArchetypesRequest {
    return SearchImplementArchetypesRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchImplementArchetypesRequest>, I>>(
    object: I,
  ): SearchImplementArchetypesRequest {
    const message = createBaseSearchImplementArchetypesRequest();
    message.query = object.query ?? undefined;
    message.pageToken = object.pageToken ?? undefined;
    message.pageSize = object.pageSize ?? undefined;
    return message;
  },
};

function createBaseSearchImplementArchetypesResponse(): SearchImplementArchetypesResponse {
  return { archetypes: [], nextPageToken: undefined };
}

export const SearchImplementArchetypesResponse: MessageFns<SearchImplementArchetypesResponse> = {
  encode(message: SearchImplementArchetypesResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.archetypes) {
      ImplementArchetype.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== undefined) {
      writer.uint32(18).string(message.nextPageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchImplementArchetypesResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchImplementArchetypesResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.archetypes.push(ImplementArchetype.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchImplementArchetypesResponse {
    return {
      archetypes: globalThis.Array.isArray(object?.archetypes)
        ? object.archetypes.map((e: any) => ImplementArchetype.fromJSON(e))
        : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : undefined,
    };
  },

  toJSON(message: SearchImplementArchetypesResponse): unknown {
    const obj: any = {};
    if (message.archetypes?.length) {
      obj.archetypes = message.archetypes.map((e) => ImplementArchetype.toJSON(e));
    }
    if (message.nextPageToken !== undefined) {
      obj.nextPageToken = message.nextPageToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchImplementArchetypesResponse>, I>>(
    base?: I,
  ): SearchImplementArchetypesResponse {
    return SearchImplementArchetypesResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchImplementArchetypesResponse>, I>>(
    object: I,
  ): SearchImplementArchetypesResponse {
    const message = createBaseSearchImplementArchetypesResponse();
    message.archetypes = object.archetypes?.map((e) => ImplementArchetype.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? undefined;
    return message;
  },
};

function createBaseSearchRigsRequest(): SearchRigsRequest {
  return {
    customerId: undefined,
    rigId: undefined,
    serial: undefined,
    pageToken: undefined,
    pageSize: undefined,
    validate: undefined,
    validationMode: undefined,
  };
}

export const SearchRigsRequest: MessageFns<SearchRigsRequest> = {
  encode(message: SearchRigsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.customerId !== undefined) {
      writer.uint32(10).string(message.customerId);
    }
    if (message.rigId !== undefined) {
      writer.uint32(42).string(message.rigId);
    }
    if (message.serial !== undefined) {
      writer.uint32(50).string(message.serial);
    }
    if (message.pageToken !== undefined) {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.pageSize !== undefined) {
      writer.uint32(24).int32(message.pageSize);
    }
    if (message.validate !== undefined) {
      writer.uint32(32).bool(message.validate);
    }
    if (message.validationMode !== undefined) {
      writer.uint32(56).int32(message.validationMode);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchRigsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchRigsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.rigId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.serial = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 32) {
            break;
          }

          message.validate = reader.bool();
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.validationMode = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchRigsRequest {
    return {
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : undefined,
      rigId: isSet(object.rigId)
        ? globalThis.String(object.rigId)
        : isSet(object.rig_id)
        ? globalThis.String(object.rig_id)
        : undefined,
      serial: isSet(object.serial) ? globalThis.String(object.serial) : undefined,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : undefined,
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : undefined,
      validate: isSet(object.validate) ? globalThis.Boolean(object.validate) : undefined,
      validationMode: isSet(object.validationMode)
        ? effectiveConfigValidationModeFromJSON(object.validationMode)
        : isSet(object.validation_mode)
        ? effectiveConfigValidationModeFromJSON(object.validation_mode)
        : undefined,
    };
  },

  toJSON(message: SearchRigsRequest): unknown {
    const obj: any = {};
    if (message.customerId !== undefined) {
      obj.customerId = message.customerId;
    }
    if (message.rigId !== undefined) {
      obj.rigId = message.rigId;
    }
    if (message.serial !== undefined) {
      obj.serial = message.serial;
    }
    if (message.pageToken !== undefined) {
      obj.pageToken = message.pageToken;
    }
    if (message.pageSize !== undefined) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.validate !== undefined) {
      obj.validate = message.validate;
    }
    if (message.validationMode !== undefined) {
      obj.validationMode = effectiveConfigValidationModeToJSON(message.validationMode);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchRigsRequest>, I>>(base?: I): SearchRigsRequest {
    return SearchRigsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchRigsRequest>, I>>(object: I): SearchRigsRequest {
    const message = createBaseSearchRigsRequest();
    message.customerId = object.customerId ?? undefined;
    message.rigId = object.rigId ?? undefined;
    message.serial = object.serial ?? undefined;
    message.pageToken = object.pageToken ?? undefined;
    message.pageSize = object.pageSize ?? undefined;
    message.validate = object.validate ?? undefined;
    message.validationMode = object.validationMode ?? undefined;
    return message;
  },
};

function createBaseSearchRigsResponse(): SearchRigsResponse {
  return { rigs: [], nextPageToken: undefined, validationResults: {} };
}

export const SearchRigsResponse: MessageFns<SearchRigsResponse> = {
  encode(message: SearchRigsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.rigs) {
      Autotractor.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== undefined) {
      writer.uint32(18).string(message.nextPageToken);
    }
    globalThis.Object.entries(message.validationResults).forEach(([key, value]: [string, ConfigValidationResult]) => {
      SearchRigsResponse_ValidationResultsEntry.encode({ key: key as any, value }, writer.uint32(26).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchRigsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchRigsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.rigs.push(Autotractor.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          const entry3 = SearchRigsResponse_ValidationResultsEntry.decode(reader, reader.uint32());
          if (entry3.value !== undefined) {
            message.validationResults[entry3.key] = entry3.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchRigsResponse {
    return {
      rigs: globalThis.Array.isArray(object?.rigs) ? object.rigs.map((e: any) => Autotractor.fromJSON(e)) : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : undefined,
      validationResults: isObject(object.validationResults)
        ? (globalThis.Object.entries(object.validationResults) as [string, any][]).reduce(
          (acc: { [key: string]: ConfigValidationResult }, [key, value]: [string, any]) => {
            acc[key] = ConfigValidationResult.fromJSON(value);
            return acc;
          },
          {},
        )
        : isObject(object.validation_results)
        ? (globalThis.Object.entries(object.validation_results) as [string, any][]).reduce(
          (acc: { [key: string]: ConfigValidationResult }, [key, value]: [string, any]) => {
            acc[key] = ConfigValidationResult.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: SearchRigsResponse): unknown {
    const obj: any = {};
    if (message.rigs?.length) {
      obj.rigs = message.rigs.map((e) => Autotractor.toJSON(e));
    }
    if (message.nextPageToken !== undefined) {
      obj.nextPageToken = message.nextPageToken;
    }
    if (message.validationResults) {
      const entries = globalThis.Object.entries(message.validationResults) as [string, ConfigValidationResult][];
      if (entries.length > 0) {
        obj.validationResults = {};
        entries.forEach(([k, v]) => {
          obj.validationResults[k] = ConfigValidationResult.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchRigsResponse>, I>>(base?: I): SearchRigsResponse {
    return SearchRigsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchRigsResponse>, I>>(object: I): SearchRigsResponse {
    const message = createBaseSearchRigsResponse();
    message.rigs = object.rigs?.map((e) => Autotractor.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? undefined;
    message.validationResults =
      (globalThis.Object.entries(object.validationResults ?? {}) as [string, ConfigValidationResult][]).reduce(
        (acc: { [key: string]: ConfigValidationResult }, [key, value]: [string, ConfigValidationResult]) => {
          if (value !== undefined) {
            acc[key] = ConfigValidationResult.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    return message;
  },
};

function createBaseSearchRigsResponse_ValidationResultsEntry(): SearchRigsResponse_ValidationResultsEntry {
  return { key: "", value: undefined };
}

export const SearchRigsResponse_ValidationResultsEntry: MessageFns<SearchRigsResponse_ValidationResultsEntry> = {
  encode(message: SearchRigsResponse_ValidationResultsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      ConfigValidationResult.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchRigsResponse_ValidationResultsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchRigsResponse_ValidationResultsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = ConfigValidationResult.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchRigsResponse_ValidationResultsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? ConfigValidationResult.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: SearchRigsResponse_ValidationResultsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = ConfigValidationResult.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchRigsResponse_ValidationResultsEntry>, I>>(
    base?: I,
  ): SearchRigsResponse_ValidationResultsEntry {
    return SearchRigsResponse_ValidationResultsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchRigsResponse_ValidationResultsEntry>, I>>(
    object: I,
  ): SearchRigsResponse_ValidationResultsEntry {
    const message = createBaseSearchRigsResponse_ValidationResultsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? ConfigValidationResult.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseSearchTractorsRequest(): SearchTractorsRequest {
  return { customerId: undefined, pageToken: undefined, pageSize: undefined, tractorId: undefined };
}

export const SearchTractorsRequest: MessageFns<SearchTractorsRequest> = {
  encode(message: SearchTractorsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.customerId !== undefined) {
      writer.uint32(10).string(message.customerId);
    }
    if (message.pageToken !== undefined) {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.pageSize !== undefined) {
      writer.uint32(24).int32(message.pageSize);
    }
    if (message.tractorId !== undefined) {
      writer.uint32(34).string(message.tractorId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchTractorsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchTractorsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.tractorId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchTractorsRequest {
    return {
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : undefined,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : undefined,
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : undefined,
      tractorId: isSet(object.tractorId)
        ? globalThis.String(object.tractorId)
        : isSet(object.tractor_id)
        ? globalThis.String(object.tractor_id)
        : undefined,
    };
  },

  toJSON(message: SearchTractorsRequest): unknown {
    const obj: any = {};
    if (message.customerId !== undefined) {
      obj.customerId = message.customerId;
    }
    if (message.pageToken !== undefined) {
      obj.pageToken = message.pageToken;
    }
    if (message.pageSize !== undefined) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.tractorId !== undefined) {
      obj.tractorId = message.tractorId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchTractorsRequest>, I>>(base?: I): SearchTractorsRequest {
    return SearchTractorsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchTractorsRequest>, I>>(object: I): SearchTractorsRequest {
    const message = createBaseSearchTractorsRequest();
    message.customerId = object.customerId ?? undefined;
    message.pageToken = object.pageToken ?? undefined;
    message.pageSize = object.pageSize ?? undefined;
    message.tractorId = object.tractorId ?? undefined;
    return message;
  },
};

function createBaseSearchTractorsResponse(): SearchTractorsResponse {
  return { tractors: [], nextPageToken: undefined };
}

export const SearchTractorsResponse: MessageFns<SearchTractorsResponse> = {
  encode(message: SearchTractorsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.tractors) {
      Tractor.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== undefined) {
      writer.uint32(18).string(message.nextPageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchTractorsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchTractorsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.tractors.push(Tractor.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchTractorsResponse {
    return {
      tractors: globalThis.Array.isArray(object?.tractors) ? object.tractors.map((e: any) => Tractor.fromJSON(e)) : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : undefined,
    };
  },

  toJSON(message: SearchTractorsResponse): unknown {
    const obj: any = {};
    if (message.tractors?.length) {
      obj.tractors = message.tractors.map((e) => Tractor.toJSON(e));
    }
    if (message.nextPageToken !== undefined) {
      obj.nextPageToken = message.nextPageToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchTractorsResponse>, I>>(base?: I): SearchTractorsResponse {
    return SearchTractorsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchTractorsResponse>, I>>(object: I): SearchTractorsResponse {
    const message = createBaseSearchTractorsResponse();
    message.tractors = object.tractors?.map((e) => Tractor.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? undefined;
    return message;
  },
};

function createBaseSearchImplementsRequest(): SearchImplementsRequest {
  return { customerId: undefined, pageToken: undefined, pageSize: undefined, implementId: undefined };
}

export const SearchImplementsRequest: MessageFns<SearchImplementsRequest> = {
  encode(message: SearchImplementsRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.customerId !== undefined) {
      writer.uint32(10).string(message.customerId);
    }
    if (message.pageToken !== undefined) {
      writer.uint32(18).string(message.pageToken);
    }
    if (message.pageSize !== undefined) {
      writer.uint32(24).int32(message.pageSize);
    }
    if (message.implementId !== undefined) {
      writer.uint32(34).string(message.implementId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchImplementsRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchImplementsRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.customerId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.pageToken = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.pageSize = reader.int32();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.implementId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchImplementsRequest {
    return {
      customerId: isSet(object.customerId)
        ? globalThis.String(object.customerId)
        : isSet(object.customer_id)
        ? globalThis.String(object.customer_id)
        : undefined,
      pageToken: isSet(object.pageToken)
        ? globalThis.String(object.pageToken)
        : isSet(object.page_token)
        ? globalThis.String(object.page_token)
        : undefined,
      pageSize: isSet(object.pageSize)
        ? globalThis.Number(object.pageSize)
        : isSet(object.page_size)
        ? globalThis.Number(object.page_size)
        : undefined,
      implementId: isSet(object.implementId)
        ? globalThis.String(object.implementId)
        : isSet(object.implement_id)
        ? globalThis.String(object.implement_id)
        : undefined,
    };
  },

  toJSON(message: SearchImplementsRequest): unknown {
    const obj: any = {};
    if (message.customerId !== undefined) {
      obj.customerId = message.customerId;
    }
    if (message.pageToken !== undefined) {
      obj.pageToken = message.pageToken;
    }
    if (message.pageSize !== undefined) {
      obj.pageSize = Math.round(message.pageSize);
    }
    if (message.implementId !== undefined) {
      obj.implementId = message.implementId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchImplementsRequest>, I>>(base?: I): SearchImplementsRequest {
    return SearchImplementsRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchImplementsRequest>, I>>(object: I): SearchImplementsRequest {
    const message = createBaseSearchImplementsRequest();
    message.customerId = object.customerId ?? undefined;
    message.pageToken = object.pageToken ?? undefined;
    message.pageSize = object.pageSize ?? undefined;
    message.implementId = object.implementId ?? undefined;
    return message;
  },
};

function createBaseSearchImplementsResponse(): SearchImplementsResponse {
  return { implements: [], nextPageToken: undefined };
}

export const SearchImplementsResponse: MessageFns<SearchImplementsResponse> = {
  encode(message: SearchImplementsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.implements) {
      Implement.encode(v!, writer.uint32(10).fork()).join();
    }
    if (message.nextPageToken !== undefined) {
      writer.uint32(18).string(message.nextPageToken);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): SearchImplementsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseSearchImplementsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.implements.push(Implement.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nextPageToken = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): SearchImplementsResponse {
    return {
      implements: globalThis.Array.isArray(object?.implements)
        ? object.implements.map((e: any) => Implement.fromJSON(e))
        : [],
      nextPageToken: isSet(object.nextPageToken)
        ? globalThis.String(object.nextPageToken)
        : isSet(object.next_page_token)
        ? globalThis.String(object.next_page_token)
        : undefined,
    };
  },

  toJSON(message: SearchImplementsResponse): unknown {
    const obj: any = {};
    if (message.implements?.length) {
      obj.implements = message.implements.map((e) => Implement.toJSON(e));
    }
    if (message.nextPageToken !== undefined) {
      obj.nextPageToken = message.nextPageToken;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<SearchImplementsResponse>, I>>(base?: I): SearchImplementsResponse {
    return SearchImplementsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<SearchImplementsResponse>, I>>(object: I): SearchImplementsResponse {
    const message = createBaseSearchImplementsResponse();
    message.implements = object.implements?.map((e) => Implement.fromPartial(e)) || [];
    message.nextPageToken = object.nextPageToken ?? undefined;
    return message;
  },
};

function createBaseRigSnapshotResponse(): RigSnapshotResponse {
  return { snapshotId: "", effectiveConfig: undefined };
}

export const RigSnapshotResponse: MessageFns<RigSnapshotResponse> = {
  encode(message: RigSnapshotResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.snapshotId !== "") {
      writer.uint32(10).string(message.snapshotId);
    }
    if (message.effectiveConfig !== undefined) {
      RigEffectiveConfig.encode(message.effectiveConfig, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): RigSnapshotResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRigSnapshotResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.snapshotId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.effectiveConfig = RigEffectiveConfig.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): RigSnapshotResponse {
    return {
      snapshotId: isSet(object.snapshotId)
        ? globalThis.String(object.snapshotId)
        : isSet(object.snapshot_id)
        ? globalThis.String(object.snapshot_id)
        : "",
      effectiveConfig: isSet(object.effectiveConfig)
        ? RigEffectiveConfig.fromJSON(object.effectiveConfig)
        : isSet(object.effective_config)
        ? RigEffectiveConfig.fromJSON(object.effective_config)
        : undefined,
    };
  },

  toJSON(message: RigSnapshotResponse): unknown {
    const obj: any = {};
    if (message.snapshotId !== "") {
      obj.snapshotId = message.snapshotId;
    }
    if (message.effectiveConfig !== undefined) {
      obj.effectiveConfig = RigEffectiveConfig.toJSON(message.effectiveConfig);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<RigSnapshotResponse>, I>>(base?: I): RigSnapshotResponse {
    return RigSnapshotResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RigSnapshotResponse>, I>>(object: I): RigSnapshotResponse {
    const message = createBaseRigSnapshotResponse();
    message.snapshotId = object.snapshotId ?? "";
    message.effectiveConfig = (object.effectiveConfig !== undefined && object.effectiveConfig !== null)
      ? RigEffectiveConfig.fromPartial(object.effectiveConfig)
      : undefined;
    return message;
  },
};

function createBaseCheckRigCompatibilityResponse(): CheckRigCompatibilityResponse {
  return { status: 0 };
}

export const CheckRigCompatibilityResponse: MessageFns<CheckRigCompatibilityResponse> = {
  encode(message: CheckRigCompatibilityResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.status !== 0) {
      writer.uint32(8).int32(message.status);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): CheckRigCompatibilityResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseCheckRigCompatibilityResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.status = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): CheckRigCompatibilityResponse {
    return { status: isSet(object.status) ? rigCompatibilityStatusFromJSON(object.status) : 0 };
  },

  toJSON(message: CheckRigCompatibilityResponse): unknown {
    const obj: any = {};
    if (message.status !== 0) {
      obj.status = rigCompatibilityStatusToJSON(message.status);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<CheckRigCompatibilityResponse>, I>>(base?: I): CheckRigCompatibilityResponse {
    return CheckRigCompatibilityResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<CheckRigCompatibilityResponse>, I>>(
    object: I,
  ): CheckRigCompatibilityResponse {
    const message = createBaseCheckRigCompatibilityResponse();
    message.status = object.status ?? 0;
    return message;
  },
};

function createBaseListCompatibleRobotsResponse(): ListCompatibleRobotsResponse {
  return { robots: {} };
}

export const ListCompatibleRobotsResponse: MessageFns<ListCompatibleRobotsResponse> = {
  encode(message: ListCompatibleRobotsResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    globalThis.Object.entries(message.robots).forEach(([key, value]: [string, CheckRigCompatibilityResponse]) => {
      ListCompatibleRobotsResponse_RobotsEntry.encode({ key: key as any, value }, writer.uint32(10).fork()).join();
    });
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCompatibleRobotsResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCompatibleRobotsResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          const entry1 = ListCompatibleRobotsResponse_RobotsEntry.decode(reader, reader.uint32());
          if (entry1.value !== undefined) {
            message.robots[entry1.key] = entry1.value;
          }
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCompatibleRobotsResponse {
    return {
      robots: isObject(object.robots)
        ? (globalThis.Object.entries(object.robots) as [string, any][]).reduce(
          (acc: { [key: string]: CheckRigCompatibilityResponse }, [key, value]: [string, any]) => {
            acc[key] = CheckRigCompatibilityResponse.fromJSON(value);
            return acc;
          },
          {},
        )
        : {},
    };
  },

  toJSON(message: ListCompatibleRobotsResponse): unknown {
    const obj: any = {};
    if (message.robots) {
      const entries = globalThis.Object.entries(message.robots) as [string, CheckRigCompatibilityResponse][];
      if (entries.length > 0) {
        obj.robots = {};
        entries.forEach(([k, v]) => {
          obj.robots[k] = CheckRigCompatibilityResponse.toJSON(v);
        });
      }
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCompatibleRobotsResponse>, I>>(base?: I): ListCompatibleRobotsResponse {
    return ListCompatibleRobotsResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCompatibleRobotsResponse>, I>>(object: I): ListCompatibleRobotsResponse {
    const message = createBaseListCompatibleRobotsResponse();
    message.robots = (globalThis.Object.entries(object.robots ?? {}) as [string, CheckRigCompatibilityResponse][])
      .reduce(
        (
          acc: { [key: string]: CheckRigCompatibilityResponse },
          [key, value]: [string, CheckRigCompatibilityResponse],
        ) => {
          if (value !== undefined) {
            acc[key] = CheckRigCompatibilityResponse.fromPartial(value);
          }
          return acc;
        },
        {},
      );
    return message;
  },
};

function createBaseListCompatibleRobotsResponse_RobotsEntry(): ListCompatibleRobotsResponse_RobotsEntry {
  return { key: "", value: undefined };
}

export const ListCompatibleRobotsResponse_RobotsEntry: MessageFns<ListCompatibleRobotsResponse_RobotsEntry> = {
  encode(message: ListCompatibleRobotsResponse_RobotsEntry, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.key !== "") {
      writer.uint32(10).string(message.key);
    }
    if (message.value !== undefined) {
      CheckRigCompatibilityResponse.encode(message.value, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ListCompatibleRobotsResponse_RobotsEntry {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseListCompatibleRobotsResponse_RobotsEntry();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.key = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.value = CheckRigCompatibilityResponse.decode(reader, reader.uint32());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ListCompatibleRobotsResponse_RobotsEntry {
    return {
      key: isSet(object.key) ? globalThis.String(object.key) : "",
      value: isSet(object.value) ? CheckRigCompatibilityResponse.fromJSON(object.value) : undefined,
    };
  },

  toJSON(message: ListCompatibleRobotsResponse_RobotsEntry): unknown {
    const obj: any = {};
    if (message.key !== "") {
      obj.key = message.key;
    }
    if (message.value !== undefined) {
      obj.value = CheckRigCompatibilityResponse.toJSON(message.value);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ListCompatibleRobotsResponse_RobotsEntry>, I>>(
    base?: I,
  ): ListCompatibleRobotsResponse_RobotsEntry {
    return ListCompatibleRobotsResponse_RobotsEntry.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ListCompatibleRobotsResponse_RobotsEntry>, I>>(
    object: I,
  ): ListCompatibleRobotsResponse_RobotsEntry {
    const message = createBaseListCompatibleRobotsResponse_RobotsEntry();
    message.key = object.key ?? "";
    message.value = (object.value !== undefined && object.value !== null)
      ? CheckRigCompatibilityResponse.fromPartial(object.value)
      : undefined;
    return message;
  },
};

function createBaseGetNextRigEffectiveConfigRequest(): GetNextRigEffectiveConfigRequest {
  return { timestampMs: 0 };
}

export const GetNextRigEffectiveConfigRequest: MessageFns<GetNextRigEffectiveConfigRequest> = {
  encode(message: GetNextRigEffectiveConfigRequest, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.timestampMs !== 0) {
      writer.uint32(8).int64(message.timestampMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextRigEffectiveConfigRequest {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextRigEffectiveConfigRequest();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.timestampMs = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextRigEffectiveConfigRequest {
    return {
      timestampMs: isSet(object.timestampMs)
        ? globalThis.Number(object.timestampMs)
        : isSet(object.timestamp_ms)
        ? globalThis.Number(object.timestamp_ms)
        : 0,
    };
  },

  toJSON(message: GetNextRigEffectiveConfigRequest): unknown {
    const obj: any = {};
    if (message.timestampMs !== 0) {
      obj.timestampMs = Math.round(message.timestampMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextRigEffectiveConfigRequest>, I>>(
    base?: I,
  ): GetNextRigEffectiveConfigRequest {
    return GetNextRigEffectiveConfigRequest.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextRigEffectiveConfigRequest>, I>>(
    object: I,
  ): GetNextRigEffectiveConfigRequest {
    const message = createBaseGetNextRigEffectiveConfigRequest();
    message.timestampMs = object.timestampMs ?? 0;
    return message;
  },
};

function createBaseGetNextRigEffectiveConfigResponse(): GetNextRigEffectiveConfigResponse {
  return { config: undefined, validationResult: undefined, timestampMs: 0 };
}

export const GetNextRigEffectiveConfigResponse: MessageFns<GetNextRigEffectiveConfigResponse> = {
  encode(message: GetNextRigEffectiveConfigResponse, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.config !== undefined) {
      RigEffectiveConfig.encode(message.config, writer.uint32(10).fork()).join();
    }
    if (message.validationResult !== undefined) {
      ConfigValidationResult.encode(message.validationResult, writer.uint32(18).fork()).join();
    }
    if (message.timestampMs !== 0) {
      writer.uint32(24).int64(message.timestampMs);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): GetNextRigEffectiveConfigResponse {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseGetNextRigEffectiveConfigResponse();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.config = RigEffectiveConfig.decode(reader, reader.uint32());
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.validationResult = ConfigValidationResult.decode(reader, reader.uint32());
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.timestampMs = longToNumber(reader.int64());
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): GetNextRigEffectiveConfigResponse {
    return {
      config: isSet(object.config) ? RigEffectiveConfig.fromJSON(object.config) : undefined,
      validationResult: isSet(object.validationResult)
        ? ConfigValidationResult.fromJSON(object.validationResult)
        : isSet(object.validation_result)
        ? ConfigValidationResult.fromJSON(object.validation_result)
        : undefined,
      timestampMs: isSet(object.timestampMs)
        ? globalThis.Number(object.timestampMs)
        : isSet(object.timestamp_ms)
        ? globalThis.Number(object.timestamp_ms)
        : 0,
    };
  },

  toJSON(message: GetNextRigEffectiveConfigResponse): unknown {
    const obj: any = {};
    if (message.config !== undefined) {
      obj.config = RigEffectiveConfig.toJSON(message.config);
    }
    if (message.validationResult !== undefined) {
      obj.validationResult = ConfigValidationResult.toJSON(message.validationResult);
    }
    if (message.timestampMs !== 0) {
      obj.timestampMs = Math.round(message.timestampMs);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<GetNextRigEffectiveConfigResponse>, I>>(
    base?: I,
  ): GetNextRigEffectiveConfigResponse {
    return GetNextRigEffectiveConfigResponse.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<GetNextRigEffectiveConfigResponse>, I>>(
    object: I,
  ): GetNextRigEffectiveConfigResponse {
    const message = createBaseGetNextRigEffectiveConfigResponse();
    message.config = (object.config !== undefined && object.config !== null)
      ? RigEffectiveConfig.fromPartial(object.config)
      : undefined;
    message.validationResult = (object.validationResult !== undefined && object.validationResult !== null)
      ? ConfigValidationResult.fromPartial(object.validationResult)
      : undefined;
    message.timestampMs = object.timestampMs ?? 0;
    return message;
  },
};

function createBaseConfigValidationDetails(): ConfigValidationDetails {
  return {
    statusCode: 0,
    implementId: undefined,
    scvConnectionId: undefined,
    scvInputId: undefined,
    scvOutputId: undefined,
    hitchType: undefined,
    ptoSpeed: undefined,
    ptoType: undefined,
    actionId: undefined,
    activity: undefined,
  };
}

export const ConfigValidationDetails: MessageFns<ConfigValidationDetails> = {
  encode(message: ConfigValidationDetails, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.statusCode !== 0) {
      writer.uint32(8).int32(message.statusCode);
    }
    if (message.implementId !== undefined) {
      writer.uint32(18).string(message.implementId);
    }
    if (message.scvConnectionId !== undefined) {
      writer.uint32(26).string(message.scvConnectionId);
    }
    if (message.scvInputId !== undefined) {
      writer.uint32(34).string(message.scvInputId);
    }
    if (message.scvOutputId !== undefined) {
      writer.uint32(42).string(message.scvOutputId);
    }
    if (message.hitchType !== undefined) {
      writer.uint32(48).int32(message.hitchType);
    }
    if (message.ptoSpeed !== undefined) {
      writer.uint32(56).int32(message.ptoSpeed);
    }
    if (message.ptoType !== undefined) {
      writer.uint32(64).int32(message.ptoType);
    }
    if (message.actionId !== undefined) {
      writer.uint32(74).string(message.actionId);
    }
    if (message.activity !== undefined) {
      writer.uint32(80).int32(message.activity);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigValidationDetails {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigValidationDetails();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 8) {
            break;
          }

          message.statusCode = reader.int32() as any;
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.implementId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.scvConnectionId = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.scvInputId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.scvOutputId = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.hitchType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.ptoSpeed = reader.int32() as any;
          continue;
        }
        case 8: {
          if (tag !== 64) {
            break;
          }

          message.ptoType = reader.int32() as any;
          continue;
        }
        case 9: {
          if (tag !== 74) {
            break;
          }

          message.actionId = reader.string();
          continue;
        }
        case 10: {
          if (tag !== 80) {
            break;
          }

          message.activity = reader.int32() as any;
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigValidationDetails {
    return {
      statusCode: isSet(object.statusCode)
        ? configValidationStatusCodeFromJSON(object.statusCode)
        : isSet(object.status_code)
        ? configValidationStatusCodeFromJSON(object.status_code)
        : 0,
      implementId: isSet(object.implementId)
        ? globalThis.String(object.implementId)
        : isSet(object.implement_id)
        ? globalThis.String(object.implement_id)
        : undefined,
      scvConnectionId: isSet(object.scvConnectionId)
        ? globalThis.String(object.scvConnectionId)
        : isSet(object.scv_connection_id)
        ? globalThis.String(object.scv_connection_id)
        : undefined,
      scvInputId: isSet(object.scvInputId)
        ? globalThis.String(object.scvInputId)
        : isSet(object.scv_input_id)
        ? globalThis.String(object.scv_input_id)
        : undefined,
      scvOutputId: isSet(object.scvOutputId)
        ? globalThis.String(object.scvOutputId)
        : isSet(object.scv_output_id)
        ? globalThis.String(object.scv_output_id)
        : undefined,
      hitchType: isSet(object.hitchType)
        ? hitchTypeFromJSON(object.hitchType)
        : isSet(object.hitch_type)
        ? hitchTypeFromJSON(object.hitch_type)
        : undefined,
      ptoSpeed: isSet(object.ptoSpeed)
        ? ptoSpeedFromJSON(object.ptoSpeed)
        : isSet(object.pto_speed)
        ? ptoSpeedFromJSON(object.pto_speed)
        : undefined,
      ptoType: isSet(object.ptoType)
        ? ptoTypeFromJSON(object.ptoType)
        : isSet(object.pto_type)
        ? ptoTypeFromJSON(object.pto_type)
        : undefined,
      actionId: isSet(object.actionId)
        ? globalThis.String(object.actionId)
        : isSet(object.action_id)
        ? globalThis.String(object.action_id)
        : undefined,
      activity: isSet(object.activity) ? autonomousActivityTypeFromJSON(object.activity) : undefined,
    };
  },

  toJSON(message: ConfigValidationDetails): unknown {
    const obj: any = {};
    if (message.statusCode !== 0) {
      obj.statusCode = configValidationStatusCodeToJSON(message.statusCode);
    }
    if (message.implementId !== undefined) {
      obj.implementId = message.implementId;
    }
    if (message.scvConnectionId !== undefined) {
      obj.scvConnectionId = message.scvConnectionId;
    }
    if (message.scvInputId !== undefined) {
      obj.scvInputId = message.scvInputId;
    }
    if (message.scvOutputId !== undefined) {
      obj.scvOutputId = message.scvOutputId;
    }
    if (message.hitchType !== undefined) {
      obj.hitchType = hitchTypeToJSON(message.hitchType);
    }
    if (message.ptoSpeed !== undefined) {
      obj.ptoSpeed = ptoSpeedToJSON(message.ptoSpeed);
    }
    if (message.ptoType !== undefined) {
      obj.ptoType = ptoTypeToJSON(message.ptoType);
    }
    if (message.actionId !== undefined) {
      obj.actionId = message.actionId;
    }
    if (message.activity !== undefined) {
      obj.activity = autonomousActivityTypeToJSON(message.activity);
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigValidationDetails>, I>>(base?: I): ConfigValidationDetails {
    return ConfigValidationDetails.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigValidationDetails>, I>>(object: I): ConfigValidationDetails {
    const message = createBaseConfigValidationDetails();
    message.statusCode = object.statusCode ?? 0;
    message.implementId = object.implementId ?? undefined;
    message.scvConnectionId = object.scvConnectionId ?? undefined;
    message.scvInputId = object.scvInputId ?? undefined;
    message.scvOutputId = object.scvOutputId ?? undefined;
    message.hitchType = object.hitchType ?? undefined;
    message.ptoSpeed = object.ptoSpeed ?? undefined;
    message.ptoType = object.ptoType ?? undefined;
    message.actionId = object.actionId ?? undefined;
    message.activity = object.activity ?? undefined;
    return message;
  },
};

function createBaseConfigValidationResult(): ConfigValidationResult {
  return { warnings: [], errors: [] };
}

export const ConfigValidationResult: MessageFns<ConfigValidationResult> = {
  encode(message: ConfigValidationResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    for (const v of message.warnings) {
      ConfigValidationDetails.encode(v!, writer.uint32(10).fork()).join();
    }
    for (const v of message.errors) {
      ConfigValidationDetails.encode(v!, writer.uint32(18).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ConfigValidationResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    const end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseConfigValidationResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.warnings.push(ConfigValidationDetails.decode(reader, reader.uint32()));
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.errors.push(ConfigValidationDetails.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ConfigValidationResult {
    return {
      warnings: globalThis.Array.isArray(object?.warnings)
        ? object.warnings.map((e: any) => ConfigValidationDetails.fromJSON(e))
        : [],
      errors: globalThis.Array.isArray(object?.errors)
        ? object.errors.map((e: any) => ConfigValidationDetails.fromJSON(e))
        : [],
    };
  },

  toJSON(message: ConfigValidationResult): unknown {
    const obj: any = {};
    if (message.warnings?.length) {
      obj.warnings = message.warnings.map((e) => ConfigValidationDetails.toJSON(e));
    }
    if (message.errors?.length) {
      obj.errors = message.errors.map((e) => ConfigValidationDetails.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ConfigValidationResult>, I>>(base?: I): ConfigValidationResult {
    return ConfigValidationResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ConfigValidationResult>, I>>(object: I): ConfigValidationResult {
    const message = createBaseConfigValidationResult();
    message.warnings = object.warnings?.map((e) => ConfigValidationDetails.fromPartial(e)) || [];
    message.errors = object.errors?.map((e) => ConfigValidationDetails.fromPartial(e)) || [];
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function longToNumber(int64: { toString(): string }): number {
  const num = globalThis.Number(int64.toString());
  if (num > globalThis.Number.MAX_SAFE_INTEGER) {
    throw new globalThis.Error("Value is larger than Number.MAX_SAFE_INTEGER");
  }
  if (num < globalThis.Number.MIN_SAFE_INTEGER) {
    throw new globalThis.Error("Value is smaller than Number.MIN_SAFE_INTEGER");
  }
  return num;
}

function isObject(value: any): boolean {
  return typeof value === "object" && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
